import { ClickAwayListener } from '@material-ui/core';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { FlatButton } from '../../../components/button/FlatButton';
import { validatePermission } from '../../../containers/authorization-helpers/validate-permission';
import { Permissions } from '../../../models/enums/permissions';
import { IApplicationState } from '../../../store/IApplicationState';

export interface IStopAction {
    id: string;
    text: string;
    icon: string;
    classes?: string;
    requiredPermissions: Permissions[];
    onClick: () => void;
}

interface IProps {
    actions: IStopAction[];
}

/**
 * The actions dropdown in the heading of a stop. An action the user is not permitted to
 * take is left out, and so is the whole menu when none are left.
 */
export const StopActionsMenu = (props: IProps) => {

    const currentPermissions = useSelector((state: IApplicationState) => state.userdata.user.permissions);
    const [isOpen, setIsOpen] = React.useState<boolean>(false);

    const permitted = props.actions.filter((action) =>
        validatePermission({ currentPermissions, requiredPermissions: action.requiredPermissions }));

    if (permitted.length === 0) {
        return null;
    }

    const toggle = () => {
        setIsOpen(!isOpen);
    };

    const hide = () => {
        setIsOpen(false);
    };

    const onActionClick = (action: IStopAction) => {
        hide();
        action.onClick();
    };

    return <ClickAwayListener
        key="stop-actions-clickaway-1"
        onClickAway={hide}>
        <span className="combo-create-widget">
            <button
                className="btn"
                data-testid="stop-content-actions"
                onClick={toggle}>
                Actions
                <i className="la la-angle-down" />
            </button>
            {
                isOpen
                    ? <div className="dropdown-menu show">
                        {
                            permitted.map((action: IStopAction) =>
                                <FlatButton
                                    key={action.id}
                                    id={action.id}
                                    text={action.text}
                                    icon={action.icon}
                                    classes={action.classes}
                                    onBtnClick={() => onActionClick(action)}
                                />
                            )
                        }
                    </div>
                    : null
            }
        </span>
    </ClickAwayListener>;
};
